export default "__VITE_ASSET__uIpQ$6mR__"